// extracted by mini-css-extract-plugin
export var notificationHost = "_bu-0";